<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un operador de sala</option>        
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los operadores</option>
        <option v-for="Operador in Operadores" :value="Operador.IdUsuario">{{Operador.Nombre | uppercase}} {{Operador.ApellidoPaterno | uppercase}} {{Operador.ApellidoMaterno | uppercase}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        enumeraciones,
        Operadores: [],        
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    filters:{
      uppercase: function(element) {
        return element.toUpperCase();
      }
    },
    mounted() {      
      if (this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_Cuentas_Usuarios_Establecer001OperadorDeSala", parametros);
    },
    methods: {
      cargaCatalogoOperadoresSalas() { 
        comun.SeEstaCargandoInformacion(true);                           
        let parametros = {
          conPersona: true,
          conPermisos: false,
          PuestoId: enumeraciones.puestos.OperadoresDeSala,
          puestoJuridicoId: enumeraciones.puestosJuridicos.OperadoresDeSala
        }

        axios.post(api.conexion + api.Cuentas.usuarios.C001Usuarios, parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Operadores = respuesta.data.Usuarios;              
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {        
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_Cuentas_Usuarios_Establecer001OperadorDeSala", parametros);
        this.$emit("valorParaElPadre", evento);
      }
    },
    created() {
      this.cargaCatalogoOperadoresSalas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Cuentas/Usuarios/001OperadoresDeSala.vue